module.exports = __webpack_public_path__ + "zillow-home-logo-3hliBQC.svg";